// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'rounded-small';

export const Component = () => (
  <g fill='none' stroke='transparent' strokeLinecap='round' strokeLinejoin='round'>
    <path fill='#D0E0F7' d='M0 4a3 3 0 0 1 3-3h15v17H0V4Z' />
    <path
      fill='#4185DE'
      d='M0 4a4 4 0 0 1 4-4h14v2H4a2 2 0 0 0-2 2H0Zm18 14H0h18ZM0 18V4a4 4 0 0 1 4-4v2a2 2 0 0 0-2 2v14H0ZM18 1v17V1Z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
